import { defineComponent as U, openBlock as c, createBlock as Y, resolveDynamicComponent as pe, normalizeClass as j, withCtx as w, createElementBlock as f, Fragment as E, createTextVNode as ce, toDisplayString as le, computed as q, isReactive as Ce, toRaw as ke, isRef as fe, ref as b, reactive as G, watch as N, onMounted as x, withDirectives as we, vModelDynamic as Ie, withModifiers as K, mergeProps as J, unref as D, inject as Be, renderSlot as v, renderList as H, createCommentVNode as F, useSlots as ve, createVNode as A, createSlots as ae, createElementVNode as L, withKeys as re, useCssVars as Ve, nextTick as Fe, onUnmounted as De, Teleport as qe, Transition as Ue } from "vue";
const me = /* @__PURE__ */ U({
  __name: "counter",
  props: {
    count: {},
    limit: {},
    tag: {}
  },
  setup(a) {
    return (t, e) => (c(), Y(pe(t.tag ?? "span"), {
      class: j(["counter", { exceeded: t.limit && (t.count ?? 0) > t.limit }])
    }, {
      default: w(() => [
        t.limit ? (c(), f(E, { key: 1 }, [
          ce(le(t.count ?? 0) + " / " + le(t.limit), 1)
        ], 64)) : (c(), f(E, { key: 0 }, [
          ce(le(t.count ?? 0), 1)
        ], 64))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ae = /* @__PURE__ */ U({
  __name: "text-counter",
  props: {
    limit: {},
    value: {},
    tag: {},
    type: {}
  },
  setup(a) {
    const t = a, e = q(() => t.value?.trim().split(t.type === "word" ? " " : "").length || 0);
    return (n, s) => (c(), Y(me, {
      tag: n.tag,
      limit: n.limit,
      count: e.value
    }, null, 8, ["tag", "limit", "count"]));
  }
});
function Se(a) {
  return a !== null && !Array.isArray(a) && typeof a == "object";
}
function Ne(a) {
  return Ce(a) ? { ...ke(a) } : fe(a) ? JSON.parse(JSON.stringify(a.value)) : a;
}
function $(a) {
  const t = Ne(a);
  for (const e in t) {
    const n = t[e];
    !Se(n) && !Array.isArray(n) || (t[e] = $(n));
  }
  return t;
}
const Te = ["checked", "id", "name", "type"], _e = /* @__PURE__ */ U({
  __name: "checkable-input",
  props: {
    type: {},
    name: {},
    value: {},
    checked: { type: Boolean }
  },
  emits: ["focused", "blurred", "created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = b(), s = b(!1), r = G({
      name: e.name,
      value: e.value,
      checked: e.checked ?? !1
    }), d = q({
      get: () => r.checked,
      set: () => {
        r.checked = !!n.value?.checked, t("updated", $(r));
      }
    });
    N(
      () => e.checked,
      (g) => {
        r.checked = !!g;
      }
    );
    const i = () => {
      e.type !== "radio" || !r.checked || t("updated", $(r));
    }, h = () => {
      s.value = !0, t("focused");
    }, l = () => {
      s.value = !1, t("blurred");
    };
    return x(() => t("created", $(r))), (g, B) => we((c(), f("input", {
      "onUpdate:modelValue": B[0] || (B[0] = (y) => d.value = y),
      autocomplete: "off",
      class: j(["checkable-input", { focused: s.value }]),
      ref_key: "element",
      ref: n,
      checked: r.checked,
      id: `${g.name}-${g.value}`,
      name: g.name,
      type: g.type,
      onBlur: l,
      onFocus: h,
      onClick: i
    }, null, 42, Te)), [
      [Ie, d.value]
    ]);
  }
});
function he(a, t) {
  return a ? t ? (a.match(t) || []).join("") : a : null;
}
function ge(a, t) {
  return a ? t === "uppercase" ? a.toUpperCase() : a.toLowerCase() : null;
}
function oe(a, t) {
  return a ? t ? a.slice(0, t) : a : null;
}
const Oe = /* @__PURE__ */ U({
  __name: "text-input",
  props: {
    name: {},
    value: {},
    textarea: { type: Boolean },
    focus: { type: Boolean },
    max: {},
    allowedCharacters: {},
    transformInput: {}
  },
  emits: ["focused", "blurred", "created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = b(null), s = b(!1), r = b(p(e.allowedCharacters)), d = q(() => i.value), i = G({
      name: e.name,
      value: e.value ?? null
    });
    function h(u) {
      if (u === null) {
        i.value = null, t("updated", $(i));
        return;
      }
      const _ = y(u ?? i.value);
      _ !== i.value && (i.value = _, t("updated", $(i)));
    }
    N(
      () => e.value,
      (u) => {
        u !== i.value && h(u);
      }
    ), N(
      () => e.allowedCharacters,
      () => {
        r.value = p(e.allowedCharacters), h();
      }
    ), N([() => e.transformInput, () => e.max], () => {
      h();
    });
    const l = (u) => {
      h(u.clipboardData?.getData("text"));
    }, g = (u) => {
      h(u.target.value);
    }, B = (u) => {
      r.value && !r.value.test(u.key) && u.preventDefault();
    };
    N(
      () => e.focus,
      (u) => {
        s.value !== u && (u ? n.value?.focus() : n.value?.blur());
      }
    );
    function y(u) {
      let _ = he(u?.trimStart(), r.value);
      return !_ || (_ = oe(_, e.max), !e.transformInput) ? _ : ge(_, e.transformInput);
    }
    function p(u) {
      if (!u)
        return null;
      const _ = { letters: "[A-Za-z]", numbers: "[0-9]" };
      return new RegExp(Object.keys(_).includes(u) ? _[u] : u, "g");
    }
    const C = () => {
      s.value = !0, t("focused");
    }, m = () => {
      s.value = !1, t("blurred");
    };
    return x(() => {
      e.focus && n.value && n.value.focus(), e.value && (e.allowedCharacters || e.transformInput || e.max) && (i.value = y(e.value)), t("created", $(i));
    }), (u, _) => (c(), Y(pe(u.textarea ? "textarea" : "input"), {
      id: u.name,
      ref_key: "element",
      ref: n,
      class: j(["text-input", { focused: s.value }]),
      maxLength: u.max,
      name: u.name,
      value: d.value,
      onBlur: m,
      onFocus: C,
      onInput: g,
      onKeypress: B,
      onPaste: K(l, ["prevent"])
    }, null, 40, ["id", "class", "maxLength", "name", "value", "onPaste"]));
  }
});
const R = (a, t) => {
  const e = a.__vccOpts || a;
  for (const [n, s] of t)
    e[n] = s;
  return e;
}, te = /* @__PURE__ */ R(Oe, [["__scopeId", "data-v-f35bd524"]]);
function se(a, t) {
  return !a || !t ? a : Object.keys(a).reduce((e, n) => (t.includes(n) || (e[n] = a[n]), e), {});
}
function ye(a, t) {
  return !a || !t ? a : Object.keys(a).reduce((e, n) => (t.includes(n) && (e[n] = a[n]), e), {});
}
function Ee(a, t, e) {
  let n = a?.replace(/\s/g, "");
  return n ? (n = t ? n.replace(/[.,](?=.*[.,])/g, "") : n.replace(/[.,]/g, ""), n = e ? n[0] + n.slice(1).replace(/-/g, "") : n.replace(/-/g, ""), n) : null;
}
function je(a, t = !0, e = !0) {
  const n = Ee(a, t, e);
  if (!n)
    return null;
  const s = Number(n.replace(",", "."));
  return isNaN(s) ? null : s;
}
const Me = {
  inheritAttrs: !1
}, $e = /* @__PURE__ */ U({
  ...Me,
  __name: "numeric-input",
  props: {
    name: {},
    value: {},
    allowDecimals: { type: Boolean, default: !0 },
    allowNegative: { type: Boolean, default: !0 }
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = q(() => `[0-9${e.allowDecimals ? ".," : ""}${e.allowNegative ? "-" : ""}]`), s = q(() => r.value?.toString() ?? null), r = G({
      name: e.name,
      value: e.value ?? null
    });
    N(
      () => e.value,
      (l) => {
        l !== r.value && (r.value = l ?? null);
      }
    );
    const d = (l) => je(l.value ?? "", e.allowDecimals, e.allowNegative), i = (l) => {
      r.value = d(l), t("created", $(r));
    }, h = (l) => {
      r.value = d(l), t("updated", $(r));
    };
    return (l, g) => (c(), Y(te, J(D(se)(l.$attrs, ["class", "onCreated", "onUpdated"]), {
      "allowed-characters": n.value,
      inputmode: l.allowDecimals ? "decimal" : "numeric",
      name: l.name,
      value: s.value,
      onUpdated: h,
      onCreated: i
    }), null, 16, ["allowed-characters", "inputmode", "name", "value"]));
  }
});
function Pe(a, t) {
  return !t || (a?.value || 0) >= t;
}
function ze(a, t) {
  return !t || (a?.value || 0) <= t;
}
function Le(a, t = !0) {
  const e = ie(a);
  return !t || !!e.length && e.every((n) => n != null);
}
function Re(a, t) {
  return !t || ie(a).length >= t;
}
function Ke(a, t) {
  return !t || ie(a).length <= t;
}
function ie(a) {
  return a?.value || [];
}
function Je(a, t = !0) {
  return !t || !!a && (!!a.value || a.value === 0);
}
function He(a, t) {
  const e = be(a);
  return !t || e.length >= t;
}
function Ye(a, t) {
  const e = be(a);
  return !t || e.length <= t;
}
function be(a) {
  return a?.value || "";
}
const O = {
  required: {
    name: "required",
    validator: (a, ...t) => Je(a, t[0] ?? null)
  },
  "max-length": {
    name: "max",
    validator: (a, ...t) => Ye(a, t[0] ?? null)
  },
  "min-length": {
    name: "min",
    validator: (a, ...t) => He(a, t[0] ?? null)
  },
  "max-amount": {
    name: "max",
    validator: (a, ...t) => ze(a, t[0] ?? null)
  },
  "min-amount": {
    name: "min",
    validator: (a, ...t) => Pe(a, t[0] ?? null)
  },
  "required-array": {
    name: "required",
    validator: (a, ...t) => Le(a, t[0] ?? null)
  },
  "min-array": {
    name: "min",
    validator: (a, ...t) => Re(a, t[0] ?? null)
  },
  "max-array": {
    name: "max",
    validator: (a, ...t) => Ke(a, t[0] ?? null)
  }
}, Ze = () => ({
  validate: (t, e = []) => {
    const n = /* @__PURE__ */ new Set();
    for (const s of e)
      s.validator(t, ...s.parameters || []) ? n.delete(s.name) : n.add(s.name);
    return Array.from(n);
  }
}), Ge = Symbol("submitted");
function Z(a) {
  return !a || !a().length ? !1 : a().some((t) => !!t.el || Qe(t.children) || We(t.props));
}
function Qe(a) {
  return !!a && a !== "v-if" && !!Object.keys(a).length;
}
function We(a) {
  return !!a && Object.keys(a).some((t) => t !== "key");
}
const Q = /* @__PURE__ */ U({
  __name: "validator",
  props: {
    validations: {},
    triggerValidation: {},
    liveValidation: { type: Boolean }
  },
  emits: ["created", "updated", "clicked-validation"],
  setup(a, { emit: t }) {
    const e = a, n = G({
      name: null,
      value: null,
      valid: !e.validations || !e.validations.length,
      failed: []
    });
    N(
      () => e.validations,
      () => {
        y();
      }
    );
    const s = Be(Ge, b(!1)), { validate: r } = Ze(), d = b(!1);
    N(s, (p) => {
      if (!p && !e.triggerValidation) {
        d.value = !1;
        return;
      }
      y(), d.value = !0;
    });
    const i = b(null);
    N(
      () => e.triggerValidation,
      (p) => {
        if (!p) {
          n.failed = n.failed.filter((m) => m !== i.value), n.valid = !n.failed.length, d.value = !n.valid;
          return;
        }
        e.validations?.find((m) => m.name === p) && (i.value = p, n.valid = !1, d.value = !0, n.failed.includes(p) || n.failed.push(p));
      }
    );
    const h = (p) => {
      g(p, "created");
    }, l = (p) => {
      e.liveValidation && (d.value = !0), g(p, "updated");
    }, g = (p, C) => {
      const m = $(p);
      if (n.name = m.name, n.value = m.value, !e.validations || !e.validations.length)
        return n.valid = !0, n.failed = [], d.value = !1, t(C, $(n));
      const u = r(m, e.validations);
      return n.valid = !u.length, n.failed = u, t(C, $(n));
    }, B = () => {
      d.value = !n.valid;
    };
    function y() {
      const p = r(n, e.validations);
      e.triggerValidation && p.push(e.triggerValidation), n.valid = !p.length, n.failed = p, t("updated", $(n));
    }
    return (p, C) => (c(), f(E, null, [
      v(p.$slots, "default", J(p.$attrs, {
        initialize: h,
        validate: l,
        invalid: !n.valid,
        showing: d.value,
        showValidity: B
      })),
      !n.valid && d.value ? (c(!0), f(E, { key: 0 }, H(p.validations, (m) => (c(), f(E, null, [
        D(Z)(p.$slots[m.name]) && n.failed[0] === m.name ? (c(), f("strong", {
          key: 0,
          class: j(["validation-error", m.name]),
          onClick: C[0] || (C[0] = (u) => t("clicked-validation"))
        }, [
          v(p.$slots, m.name)
        ], 2)) : F("", !0)
      ], 64))), 256)) : F("", !0)
    ], 64));
  }
});
function X(...a) {
  if (!a || !a.length)
    return !1;
  const t = document.activeElement;
  return Xe(a).some((e) => !!e && (e === t || e.contains(t)));
}
function Xe(a) {
  return a.map((t) => fe(t) ? t.value : t);
}
const xe = {
  key: 0,
  class: "label"
}, ea = ["onBlurCapture"], aa = ["aria-checked", "role", "onKeypress"], ta = { class: "content" }, na = {
  key: 1,
  class: "information"
}, la = /* @__PURE__ */ U({
  __name: "checkable-field",
  props: {
    type: {},
    name: {},
    selected: {},
    disabled: {},
    required: { type: Boolean },
    min: {},
    max: {},
    validations: {},
    triggerValidation: {},
    hideInput: { type: Boolean },
    permanentInformation: { type: Boolean }
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = q(() => {
      const o = [{ ...O["required-array"], parameters: [e.required] }, ...e.validations ?? []];
      return e.type !== "radio" && o.push(
        { ...O["min-array"], parameters: [e.min] },
        { ...O["max-array"], parameters: [e.max] }
      ), o;
    }), s = ve(), r = Object.keys(s), d = ["label", "information", ...n.value.map((o) => o.name)], i = b(new Set(T(e.selected))), h = b(/* @__PURE__ */ new Set()), l = G({
      name: e.name,
      value: Array.from(i.value),
      valid: !e.required,
      failed: []
    });
    N(
      () => e.selected,
      (o) => {
        const k = T(o);
        JSON.stringify(k) !== JSON.stringify(l.value) && (i.value = new Set(k), l.value = Array.from(i.value));
      }
    );
    const g = (o) => {
      e.type === "radio" && !o.checked || B(o);
    }, B = (o) => {
      e.type === "radio" && o.checked && i.value.clear(), o.checked ? i.value.add(o.value) : i.value.delete(o.value), l.value = Array.from(i.value);
    }, y = (o) => {
      if (e.disabled && e.disabled.includes(o))
        return;
      const k = {
        name: l.name,
        value: o,
        checked: e.type !== "radio" ? !i.value.has(o) : !0
      };
      B(k);
    }, p = (o) => {
      l.valid = o.valid, l.failed = o.failed;
    }, C = (o) => {
      l.valid = o.valid, l.failed = o.failed, t("updated", $(l));
    }, m = (o) => {
      h.value.add(o);
    }, u = (o) => {
      h.value.delete(o);
    }, _ = b(null), W = (o) => {
      requestAnimationFrame(() => {
        X(_) || o();
      });
    };
    x(() => t("created", $(l)));
    function T(o) {
      return (o || []).filter((k) => k !== null);
    }
    return (o, k) => (c(), f("fieldset", {
      ref_key: "field",
      ref: _,
      class: "checkable-field input-field",
      tabindex: "-1"
    }, [
      A(Q, {
        validations: n.value,
        "trigger-validation": o.triggerValidation,
        onCreated: p,
        onUpdated: C
      }, ae({
        default: w(({ initialize: V, validate: M, invalid: P, showing: z, showValidity: ne }) => [
          D(Z)(D(s).label) ? (c(), f("header", xe, [
            v(o.$slots, "label", {}, void 0, !0)
          ])) : F("", !0),
          L("main", {
            onBlurCapture: (I) => W(ne)
          }, [
            (c(!0), f(E, null, H(D(r), (I) => (c(), f(E, { key: I }, [
              !d.includes(I) && D(Z)(D(s)[I]) ? (c(), f("label", {
                key: 0,
                class: j(["checkable-field-item", { focused: h.value.has(I), selected: l.value.includes(I), disabled: o.disabled?.includes(I) }]),
                tabindex: "0",
                "aria-checked": l.value.includes(I),
                role: o.type,
                onKeypress: re(
                  () => {
                    y(I), M(l);
                  },
                  ["space", "enter"]
                )
              }, [
                A(_e, {
                  class: j({ hidden: o.hideInput }),
                  name: `checkable-input-${o.name}`,
                  value: I,
                  type: o.type,
                  checked: l.value.includes(I),
                  disabled: o.disabled?.includes(I),
                  tabindex: "-1",
                  onFocused: (S) => m(I),
                  onBlurred: (S) => u(I),
                  onCreated: (S) => {
                    g(S), V(l);
                  },
                  onUpdated: (S) => {
                    B(S), M(l);
                  }
                }, null, 8, ["class", "name", "value", "type", "checked", "disabled", "onFocused", "onBlurred", "onCreated", "onUpdated"]),
                L("span", ta, [
                  v(o.$slots, I, {
                    selected: l.value.includes(I)
                  }, void 0, !0)
                ])
              ], 42, aa)) : F("", !0)
            ], 64))), 128))
          ], 40, ea),
          D(Z)(D(s).information) && (o.permanentInformation || !(P && z)) ? (c(), f("footer", na, [
            v(o.$slots, "information", {}, void 0, !0)
          ])) : F("", !0)
        ]),
        _: 2
      }, [
        H(n.value, (V) => ({
          name: V.name,
          fn: w(() => [
            v(o.$slots, V.name, {}, void 0, !0)
          ])
        }))
      ]), 1032, ["validations", "trigger-validation"])
    ], 512));
  }
});
const oa = /* @__PURE__ */ R(la, [["__scopeId", "data-v-83fcd38b"]]), ra = {
  key: 0,
  class: "prepend-append"
}, sa = {
  key: 0,
  class: "prepend"
}, ia = { class: "content" }, ua = {
  key: 1,
  class: "append"
}, da = /* @__PURE__ */ U({
  __name: "prepend-append",
  setup(a) {
    const t = ve(), e = q(() => Z(t.prepend)), n = q(() => Z(t.append));
    return (s, r) => e.value || n.value ? (c(), f("span", ra, [
      e.value ? (c(), f("span", sa, [
        v(s.$slots, "prepend", {}, void 0, !0)
      ])) : F("", !0),
      L("span", ia, [
        v(s.$slots, "default", {}, void 0, !0)
      ]),
      n.value ? (c(), f("span", ua, [
        v(s.$slots, "append", {}, void 0, !0)
      ])) : F("", !0)
    ])) : v(s.$slots, "default", { key: 1 }, void 0, !0);
  }
});
const ue = /* @__PURE__ */ R(da, [["__scopeId", "data-v-5ee88280"]]), ca = 400, pa = () => {
  let a;
  return {
    debounce: (e, n = ca) => {
      a && (clearTimeout(a), a = null), a = setTimeout(() => {
        e();
      }, n);
    }
  };
}, de = /* @__PURE__ */ U({
  __name: "debouncer",
  props: {
    delay: {}
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a, { debounce: n } = pa(), s = (r) => {
      if (!r || e.delay === 0)
        return t("updated", r);
      n(() => {
        t("updated", r);
      }, e.delay);
    };
    return (r, d) => v(r.$slots, "default", { debounce: s });
  }
}), fa = {
  key: 0,
  class: "label"
}, va = ["onBlurCapture"], ma = {
  key: 1,
  class: "information"
}, _a = {
  inheritAttrs: !1
}, ha = /* @__PURE__ */ U({
  ..._a,
  __name: "number-field",
  props: {
    name: {},
    value: {},
    typingDelay: {},
    allowDecimals: { type: Boolean, default: !0 },
    allowNegative: { type: Boolean, default: !0 },
    required: { type: Boolean },
    min: {},
    max: {},
    validations: {},
    triggerValidation: {},
    permanentInformation: { type: Boolean }
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = q(() => [
      { ...O.required, parameters: [e.required ?? !1] },
      { ...O["min-amount"], parameters: [e.min] },
      { ...O["max-amount"], parameters: [e.max] },
      ...e.validations ?? []
    ]), s = b(!1), r = b(null), d = (l) => {
      requestAnimationFrame(() => {
        X(r) || (s.value = !1, l());
      });
    }, i = (l) => {
      t("created", $(l));
    }, h = (l) => {
      t("updated", $(l));
    };
    return (l, g) => (c(), f("label", J({
      ref_key: "field",
      ref: r,
      class: "number-field input-field",
      tabindex: "-1"
    }, D(ye)(l.$attrs, ["class", "onClick"])), [
      A(de, {
        delay: l.typingDelay,
        onUpdated: h
      }, {
        default: w(({ debounce: B }) => [
          A(Q, {
            validations: n.value,
            "live-validation": !s.value,
            "trigger-validation": l.triggerValidation,
            onCreated: i,
            onUpdated: B
          }, ae({
            default: w(({ initialize: y, validate: p, invalid: C, showing: m, showValidity: u }) => [
              l.$slots.label ? (c(), f("header", fa, [
                v(l.$slots, "label", {}, void 0, !0)
              ])) : F("", !0),
              L("main", {
                class: j(["input", { focused: s.value, invalid: C && m }]),
                onBlurCapture: K((_) => d(u), ["prevent"])
              }, [
                A(ue, null, {
                  prepend: w(() => [
                    v(l.$slots, "prepend", {}, void 0, !0)
                  ]),
                  append: w(() => [
                    v(l.$slots, "append", {}, void 0, !0)
                  ]),
                  default: w(() => [
                    A($e, J(D(se)(l.$attrs, ["class", "onClick", "onCreated", "onUpdated"]), {
                      name: l.name,
                      value: l.value,
                      "allow-decimals": l.allowDecimals,
                      "allow-negative": l.allowNegative,
                      onFocused: g[0] || (g[0] = (_) => s.value = !0),
                      onCreated: y,
                      onUpdated: p
                    }), null, 16, ["name", "value", "allow-decimals", "allow-negative", "onCreated", "onUpdated"])
                  ]),
                  _: 2
                }, 1024)
              ], 42, va),
              l.$slots.information && (l.permanentInformation || !(C && m)) ? (c(), f("footer", ma, [
                v(l.$slots, "information", {}, void 0, !0)
              ])) : F("", !0)
            ]),
            _: 2
          }, [
            H(n.value, (y) => ({
              name: y.name,
              fn: w(() => [
                v(l.$slots, y.name, {}, void 0, !0)
              ])
            }))
          ]), 1032, ["validations", "live-validation", "trigger-validation", "onUpdated"])
        ]),
        _: 3
      }, 8, ["delay"])
    ], 16));
  }
});
const ga = /* @__PURE__ */ R(ha, [["__scopeId", "data-v-1dab51aa"]]), ya = /* @__PURE__ */ U({
  __name: "one-time-code-field-item",
  props: {
    index: {},
    name: {},
    value: {},
    focus: { type: Boolean },
    validations: {},
    showValidation: { type: Boolean },
    allowedCharacters: {}
  },
  emits: ["created", "updated", "focused", "cleared"],
  setup(a, { emit: t }) {
    return (e, n) => (c(), Y(Q, {
      validations: e.validations,
      onCreated: n[2] || (n[2] = (s) => t("created", s)),
      onUpdated: n[3] || (n[3] = (s) => t("updated", s))
    }, {
      default: w(({ initialize: s, validate: r, invalid: d }) => [
        A(te, {
          class: j(["input", { invalid: d && e.showValidation }]),
          "transform-input": "uppercase",
          "allowed-characters": e.allowedCharacters,
          focus: e.focus,
          max: 1,
          name: `${e.name}-${e.index}`,
          value: e.value,
          onFocused: n[0] || (n[0] = (i) => t("focused")),
          onCreated: s,
          onUpdated: r,
          onKeydown: n[1] || (n[1] = re(K((i) => t("cleared"), ["prevent"]), ["delete"]))
        }, null, 8, ["allowed-characters", "class", "focus", "name", "value", "onCreated", "onUpdated"])
      ]),
      _: 1
    }, 8, ["validations"]));
  }
});
const $a = /* @__PURE__ */ R(ya, [["__scopeId", "data-v-714e21f2"]]), ba = ["onPaste"], Ca = ["onBlurCapture"], ka = /* @__PURE__ */ U({
  __name: "one-time-code-field",
  props: {
    name: {},
    focus: { type: Boolean },
    required: { type: Boolean },
    validations: {},
    triggerValidation: {},
    type: { default: "alphanumeric" },
    length: { default: 6 },
    permanentInformation: { type: Boolean }
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a;
    Ve((o) => ({
      afbaa9a8: e.length.toString()
    }));
    const n = q(() => [{ ...O.required, parameters: [e.required] }]), s = q(() => [
      {
        name: "required",
        parameters: [e.required, e.length],
        validator: (o, ...k) => {
          const V = k[0], M = k[1], P = o.value;
          return !V || !!P && P.length === M && P.every((z) => z !== null);
        }
      },
      ...e.validations ?? []
    ]), r = G({
      name: e.name,
      value: [],
      valid: !e.required,
      failed: e.required ? ["required"] : []
    }), d = b(e.focus ? 0 : -1), i = q({
      get: () => d.value ?? r.value.indexOf(null),
      set: (o) => {
        d.value = o !== null && o < e.length ? o : null;
      }
    });
    N(
      () => e.focus,
      (o) => {
        if (o)
          return T();
        i.value = -1;
      }
    );
    const h = (o, k, V) => {
      r.value[o] = oe(k.value, 1), V(r), k.valid && (i.value = o + 1);
    }, l = (o) => {
      r.valid = o.valid, r.failed = o.failed;
    }, g = (o) => {
      r.valid = o.valid, r.failed = o.failed, W("updated");
    }, B = b(null), y = b(null), p = (o) => {
      requestAnimationFrame(() => {
        if (X(B)) {
          if (X(y))
            return;
          i.value = -1;
          return;
        }
        i.value = -1, o();
      });
    }, C = q(() => `[${e.type !== "numeric" ? "A-z" : ""}${e.type !== "alpha" ? "0-9" : ""}]`), m = (o) => {
      const k = o.clipboardData?.getData("text");
      if (!k)
        return T();
      const V = he(k, new RegExp(C.value, "g"));
      if (!V)
        return _(), T();
      const M = ge(oe(V, e.length), "uppercase").split("");
      r.value = [...new Array(e.length)].map((P, z) => M[z] ?? null), T(), W("updated");
    }, u = (o) => {
      if (r.value[o] === null) {
        i.value = o - 1;
        return;
      }
      r.value[o] = null;
    };
    function _() {
      r.value = [...new Array(e.length)].map(() => null);
    }
    function W(o) {
      const k = {
        name: r.name,
        value: r.value?.join("") || null,
        valid: r.valid,
        failed: r.failed
      };
      t(o, k);
    }
    function T() {
      i.value = null;
    }
    return x(() => {
      _(), W("created");
    }), (o, k) => (c(), f("fieldset", {
      ref_key: "field",
      ref: B,
      tabindex: "-1",
      class: "one-time-code-field input-field",
      onPaste: K(m, ["prevent"])
    }, [
      A(Q, {
        validations: s.value,
        "trigger-validation": o.triggerValidation,
        onCreated: l,
        onUpdated: g,
        onClickedValidation: T
      }, ae({
        default: w(({ initialize: V, validate: M, invalid: P, showing: z, showValidity: ne }) => [
          o.$slots.label ? (c(), f("header", {
            key: 0,
            class: "label",
            onClick: T
          }, [
            v(o.$slots, "label", {}, void 0, !0)
          ])) : F("", !0),
          L("main", {
            ref_key: "main",
            ref: y,
            tabindex: "-1",
            onBlurCapture: K((I) => p(ne), ["prevent"])
          }, [
            (c(!0), f(E, null, H(o.length, (I, S) => (c(), Y($a, {
              index: S,
              name: o.name,
              "allowed-characters": C.value,
              focus: S === i.value,
              "show-validation": z,
              value: r.value[S],
              validations: n.value,
              onFocused: (ee) => i.value = S,
              onCreated: (ee) => V(D($)(r)),
              onUpdated: (ee) => h(S, ee, M),
              onCleared: (ee) => u(S)
            }, null, 8, ["index", "name", "allowed-characters", "focus", "show-validation", "value", "validations", "onFocused", "onCreated", "onUpdated", "onCleared"]))), 256))
          ], 40, Ca),
          o.$slots.information && (o.permanentInformation || !(P && z)) ? (c(), f("footer", {
            key: 1,
            class: "information",
            onClick: T
          }, [
            v(o.$slots, "information", {}, void 0, !0)
          ])) : F("", !0)
        ]),
        _: 2
      }, [
        H(s.value, (V) => ({
          name: V.name,
          fn: w(() => [
            v(o.$slots, V.name, {}, void 0, !0)
          ])
        }))
      ]), 1032, ["validations", "trigger-validation"])
    ], 40, ba));
  }
});
const wa = /* @__PURE__ */ R(ka, [["__scopeId", "data-v-15d23039"]]), Ia = {
  key: 0,
  class: "label"
}, Ba = ["onBlurCapture"], Va = {
  key: 1,
  class: "information"
}, Fa = {
  inheritAttrs: !1
}, Da = /* @__PURE__ */ U({
  ...Fa,
  __name: "text-field",
  props: {
    name: {},
    value: {},
    typingDelay: {},
    allowedCharacters: {},
    maxLength: {},
    max: {},
    min: {},
    required: { type: Boolean },
    validations: {},
    triggerValidation: {},
    permanentInformation: { type: Boolean }
  },
  emits: ["created", "updated"],
  setup(a, { emit: t }) {
    const e = a, n = q(() => [
      { ...O.required, parameters: [e.required] },
      { ...O["min-length"], parameters: [e.min] },
      { ...O["max-length"], parameters: [e.max] },
      ...e.validations ?? []
    ]), s = b(!1), r = b(null), d = (l) => {
      requestAnimationFrame(() => {
        X(r) || (s.value = !1, l());
      });
    }, i = (l) => {
      t("created", $(l));
    }, h = (l) => {
      t("updated", $(l));
    };
    return (l, g) => (c(), f("label", J({
      ref_key: "field",
      ref: r,
      class: "text-field input-field",
      tabindex: "-1"
    }, D(ye)(l.$attrs, ["class", "onClick"])), [
      A(de, {
        delay: l.typingDelay,
        onUpdated: h
      }, {
        default: w(({ debounce: B }) => [
          A(Q, {
            validations: n.value,
            "trigger-validation": l.triggerValidation,
            "live-validation": !s.value,
            onCreated: i,
            onUpdated: B
          }, ae({
            default: w(({ initialize: y, validate: p, invalid: C, showing: m, showValidity: u }) => [
              l.$slots.label ? (c(), f("header", Ia, [
                v(l.$slots, "label", {}, void 0, !0)
              ])) : F("", !0),
              L("main", {
                class: j(["input", { focused: s.value, invalid: C && m }]),
                onBlurCapture: K((_) => d(u), ["prevent"])
              }, [
                A(ue, null, {
                  prepend: w(() => [
                    v(l.$slots, "prepend", {}, void 0, !0)
                  ]),
                  append: w(() => [
                    v(l.$slots, "append", {}, void 0, !0)
                  ]),
                  default: w(() => [
                    A(te, J(D(se)(l.$attrs, ["class", "onClick", "onCreated", "onUpdated"]), {
                      name: l.name,
                      value: l.value,
                      "allowed-characters": l.allowedCharacters,
                      max: l.maxLength,
                      onFocused: g[0] || (g[0] = (_) => s.value = !0),
                      onCreated: y,
                      onUpdated: p
                    }), null, 16, ["name", "value", "allowed-characters", "max", "onCreated", "onUpdated"])
                  ]),
                  _: 2
                }, 1024)
              ], 42, Ba),
              l.$slots.information && (l.permanentInformation || !(C && m)) ? (c(), f("footer", Va, [
                v(l.$slots, "information", {}, void 0, !0)
              ])) : F("", !0)
            ]),
            _: 2
          }, [
            H(n.value, (y) => ({
              name: y.name,
              fn: w(() => [
                v(l.$slots, y.name, {}, void 0, !0)
              ])
            }))
          ]), 1032, ["validations", "trigger-validation", "live-validation", "onUpdated"])
        ]),
        _: 3
      }, 8, ["delay"])
    ], 16));
  }
});
const qa = /* @__PURE__ */ R(Da, [["__scopeId", "data-v-a537f627"]]), Ua = ["onClick", "onKeydown"], Aa = { key: 0 }, Sa = { key: 1 }, Na = {
  inheritAttrs: !1
}, Ta = /* @__PURE__ */ U({
  ...Na,
  __name: "modal",
  props: {
    parent: {},
    open: { type: Boolean }
  },
  emits: ["opened", "closed"],
  setup(a, { emit: t }) {
    const e = a, n = b(null), s = b(!1);
    N(
      () => e.open,
      (i) => {
        i !== s.value && (i ? r() : d());
      }
    );
    const r = async () => {
      s.value = !0, t("opened"), await Fe(), n.value?.focus();
    }, d = () => {
      s.value = !1, t("closed");
    };
    return x(() => {
      e.open && r();
    }), De(() => {
      d();
    }), (i, h) => (c(), f(E, null, [
      v(i.$slots, "opener", { open: r }, void 0, !0),
      (c(), Y(qe, {
        to: i.parent ?? "body"
      }, [
        A(Ue, { name: "modal" }, {
          default: w(() => [
            s.value ? (c(), f("div", {
              key: 0,
              ref_key: "element",
              ref: n,
              class: "backdrop",
              tabindex: "-1",
              onClick: K(d, ["self"]),
              onKeydown: re(d, ["esc"])
            }, [
              L("div", J(i.$attrs, { class: "modal" }), [
                i.$slots.header ? (c(), f("header", Aa, [
                  v(i.$slots, "header", { close: d }, void 0, !0)
                ])) : F("", !0),
                L("main", null, [
                  v(i.$slots, "default", { close: d }, void 0, !0)
                ]),
                i.$slots.footer ? (c(), f("footer", Sa, [
                  v(i.$slots, "footer", { close: d }, void 0, !0)
                ])) : F("", !0)
              ], 16)
            ], 40, Ua)) : F("", !0)
          ]),
          _: 3
        })
      ], 8, ["to"]))
    ], 64));
  }
});
const Oa = /* @__PURE__ */ R(Ta, [["__scopeId", "data-v-e5bde5c1"]]), ja = {
  install: (a) => {
    a.component("Counter", me), a.component("TextCounter", Ae), a.component("PrependAppend", ue), a.component("CheckableInput", _e), a.component("NumericInput", $e), a.component("TextInput", te), a.component("Debouncer", de), a.component("Validator", Q), a.component("CheckableField", oa), a.component("Modal", Oa), a.component("NumberField", ga), a.component("OneTimeCodeField", wa), a.component("TextField", qa);
  }
};
export {
  oa as CheckableField,
  _e as CheckableInput,
  me as Counter,
  de as Debouncer,
  Oa as Modal,
  ga as NumberField,
  $e as NumericInput,
  wa as OneTimeCodeField,
  ue as PrependAppend,
  Ge as SubmittedSymbol,
  Ae as TextCounter,
  qa as TextField,
  te as TextInput,
  Q as Validator,
  ja as default,
  O as predefinedValidations,
  pa as useDebounce,
  Ze as useValidate
};
